// Single owner for the pending launch operation. No transport or storage side effects.
export const createLaunchOperationOwner = () => {
  let generation = 0;
  let active = null;
  return {
    hasPending: () => Boolean(active),
    begin(account) {
      if (!account || active) return null;
      active = Object.freeze({ generation, account });
      return active;
    },
    isCurrent(operation, account) {
      return Boolean(operation && active === operation && operation.generation === generation && account && operation.account === account);
    },
    finish(operation) {
      if (active === operation) active = null;
    },
    invalidate() {
      generation += 1;
      active = null;
    },
  };
};
